import { useQuery } from '@tanstack/react-query';
import { getCustomers } from '../api/customer.api';

export const useCustomerListInit = () => {
	const {
		data: customers,
		error,
		isPending,
	} = useQuery({
		queryKey: ['GET_CUSTOMER_LIST'],
		queryFn: getCustomers,
		enabled: true,
	});

	return {
		customers,
		error,
		isPending,
	};
};
